module.exports = __webpack_public_path__ + "static/img/VTour01.64cf824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/vtour/VTour01.png
// module id = OjpB
// module chunks = 1